import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../../shared/models/user.model';

import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class UserService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;

	constructor(private http: HttpClient) { }

	getAll() {
		return this.http.get<User[]>(`${this.apiUrl1}/api/users`);
	}
	getAllUserlistData()
	{
		return this.http.get(`${this.apiUrl1}/api/users`);
	}

	getPaginatedUsers(page: number, size: number) {
		return this.http.get(`${this.apiUrl1}/api/users/paginated?page=${page}&size=${size}`);
	}

	getUserIdName() {
		return this.http.get<User[]>(`${this.apiUrl}/api/get-users`);
	}

	// getUserkeyBy() {
	// 	return this.http.get<User[]>(`${this.apiUrl}/api/get-users-keyby`);
	// }

	getUserkeyBy() {
		return this.http.get<User[]>(`${this.apiUrl1}/api/get-users-keyby`);
	}

	getMailUsers() {
		return this.http.get<User[]>(`${this.apiUrl}/api/mail-users`);
	}

	getById(id: number) {
		return this.http.get(`${this.apiUrl1}/api/users/${id}`);
	}

	create(user: User) {
		return this.http.post(`${this.apiUrl1}/api/users`, user);
	}

	update(user: User) {
		return this.http.put(`${this.apiUrl1}/api/users/${user.id}`, user);
	}

	delete(id: number) {
		return this.http.delete(`${this.apiUrl1}/api/users/${id}`);
	}

	getUserPermissions() {
		return this.http.get(`${this.apiUrl}/api/users/permissions`);
	}

	setActiveDeactiveUser(user: User) {
		return this.http.put(`${this.apiUrl}/api/users/${user.id}/disable`, user);
	}

	getUserGeneratedId() {
		return this.http.get(`${this.apiUrl}/api/users/get-generated-id`);
	}

	changePassword(user) {
		return this.http.post(`${this.apiUrl}/api/users/change-password/${user.id}`, user);
	}

	changeEmail(user) {
		return this.http.post(`${this.apiUrl}/api/users/change-email/${user.id}`, user);
	}

	sendInviteUserMail(id) {
		return this.http.get(`${this.apiUrl}/api/users/invite/${id}`);
	}

	import(importUsers) {
		return this.http.post(`${this.apiUrl}/api/users/import`, importUsers);
	}

	changeLocale(locale: string) {
		return this.http.get(`${this.apiUrl}/api/user/change-locale/${locale}`);
	}
	// new api 
	createSkillData(payload:any)
	{
		return this.http.post(`${this.apiUrl1}/api/user-skills`,payload);
	}
	getSkillData()
	{
		return this.http.get(`${this.apiUrl1}/api/user-skills`);
	}
	deleteSkills(id:number)
	{
		return this.http.delete(`${this.apiUrl1}/api/user-skills/${id}`);
	}
	getSkillbyId(id:number)
	{
		return this.http.get(`${this.apiUrl1}/api/user-skills/${id}`);
	}
	updateSkillData(payload:any)
	{
			return this.http.put(`${this.apiUrl1}/api/user-skills`, payload);

    }
	//experience
	createExperience(payload:any)
	{
		return this.http.post(`${this.apiUrl1}/api/user-experience`,payload);
	}
	getExperienceData()
	{
		return this.http.get(`${this.apiUrl1}/api/user-experience`);
	}
	deleteExperience(id:number)
	{
		return this.http.delete(`${this.apiUrl1}/api/user-experience/${id}`);
	}
	getExperiencebyId(id:number)
	{
		return this.http.get(`${this.apiUrl1}/api/user-experience/${id}`);
	}
	updateExperience(payload:any)
	{
			return this.http.put(`${this.apiUrl1}/api/user-experience`, payload);
	}
	getAlluser()
	{
		return this.http.get(`${this.apiUrl1}/api/users`);
	}
}
